import React, { useRef, useEffect } from 'react';

const OutOfView = ({ className, children, onOutCallback, rootMargin = "0px", style = {} }) => {
    const ref = useRef(null);

    useEffect(() => {
        let observerRef = null;
        let observer = null;

        let handlePlay = (entries) => {
            const [entry] = entries;
            onOutCallback(entry, observer, observerRef);
        }

        try {
            observer = new IntersectionObserver(handlePlay, { rootMargin });
            if (ref.current) {
                observerRef = ref.current;
                observer.observe(ref.current);
            }
        } catch (err) {
            console.error("IntersectionObserver not supported:", err);
        }

        return () => {
            try {
                if (observer && observerRef) {
                    observer.unobserve(observerRef);
                }
            } catch (err) {}
        }
    }, [rootMargin, onOutCallback])

    return (
        <div ref={ref} className={className} style={style}>
            {children}
        </div>
    )
}

export default OutOfView;